import { render, staticRenderFns } from "./data-permission.vue?vue&type=template&id=47ae5a90&"
import script from "./data-permission.vue?vue&type=script&lang=js&"
export * from "./data-permission.vue?vue&type=script&lang=js&"
import style0 from "./data-permission.vue?vue&type=style&index=0&id=47ae5a90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports